import { useLazyQuery, useQuery } from '@apollo/client/react/hooks';
import { useContext } from 'react';
import { makeGqlContext } from '../shared';

export const HannibalContext = makeGqlContext();

export const useHannibalQuery: typeof useQuery = (document, options?) =>
  useQuery(document, { ...options, client: useContext(HannibalContext) });

export const useLazyHannibalQuery: typeof useLazyQuery = (document, options?) =>
  useLazyQuery(document, { ...options, client: useContext(HannibalContext) });
